import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const TransactionFilters = ({ 
  filters, 
  onFilterChange, 
  onReset,
  onApply
}) => {
  const { currentLanguage, t } = useLanguage();

  const statusOptions = [
    { value: 'all', label: t('financial.allStatuses') },
    { value: 'completed', label: t('financial.completed') },
    { value: 'pending', label: t('financial.pending') },
    { value: 'overdue', label: t('financial.overdue') },
    { value: 'refunded', label: t('financial.refunded') }
  ];

  const transactionTypeOptions = [
    { value: 'all', label: t('financial.allTypes') },
    { value: 'down_payment', label: t('financial.downPayment') },
    { value: 'balance', label: t('financial.balancePayment') },
    { value: 'refund', label: t('financial.refund') },
    { value: 'adjustment', label: t('financial.adjustment') }
  ];

  const groupOptions = [
    { value: 'all', label: t('financial.allGroups') },
    { value: 'omra_jan_2026', label: currentLanguage === 'fr' ? 'Omra Janvier 2026' : 'عمرة يناير 2026' },
    { value: 'hajj_2026', label: currentLanguage === 'fr' ? 'Hajj 2026' : 'حج 2026' },
    { value: 'omra_ramadan_2026', label: currentLanguage === 'fr' ? 'Omra Ramadan 2026' : 'عمرة رمضان 2026' }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 border border-border shadow-warm">
      <h3 className="text-lg font-semibold text-foreground mb-4 md:mb-6">
        {t('financial.filterBy')}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <Select
          label={t('financial.status')}
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />
        
        <Select
          label={t('financial.transactionType')}
          options={transactionTypeOptions}
          value={filters?.transactionType}
          onChange={(value) => onFilterChange('transactionType', value)}
        />
        
        <Select
          label={t('financial.group')}
          options={groupOptions}
          value={filters?.group}
          onChange={(value) => onFilterChange('group', value)}
        />
        
        <Input
          label={currentLanguage === 'fr' ? 'Date de début' : 'تاريخ البداية'}
          type="date"
          value={filters?.dateRange?.start || ''}
          onChange={(e) => onFilterChange('dateRange', { ...filters?.dateRange, start: e?.target?.value })}
        />
        
        <Input
          label={currentLanguage === 'fr' ? 'Date de fin' : 'تاريخ النهاية'}
          type="date"
          value={filters?.dateRange?.end || ''}
          onChange={(e) => onFilterChange('dateRange', { ...filters?.dateRange, end: e?.target?.value })}
        />
        
        <div>
          <Input
            label={t('financial.searchPilgrim')}
            type="search"
            placeholder={currentLanguage === 'fr' ? 'Nom, prénom ou numéro...' : 'الاسم أو الرقم...'}
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 justify-end">
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
        >
          {t('financial.reset')}
        </Button>
        <Button
          variant="default"
          iconName="Filter"
          iconPosition="left"
          onClick={onApply}
        >
          {t('financial.apply')}
        </Button>
      </div>
    </div>
  );
};

export default TransactionFilters;